/* qp-cart-build.js — display-layer cart repairs (feat/cart-mobile).
   DISPLAY-ONLY: nothing here changes line-item properties or add-to-cart
   payloads. Three fixes:

   1. m-cart-drawer-items inherits MCartTemplate.onCartUpdate, which fetches
      section_id=cart-template and (on the cart page, where isCartPage is
      true for BOTH instances) stuffs the PAGE grid — or the empty-state
      fragment — into the DRAWER body whenever a third party emits a
      cartUpdate event (the free-gift app does on auto add/remove). The
      drawer footer is never synced on that path: empty-looking body,
      frozen subtotal. Reroute the drawer instance to its own section.

   2. m-cart-drawer.onCartDrawerUpdate resolves its swap selectors
      document-wide; on the cart page [data-cart-subtotal] matches the
      page's canonical block first, so the drawer footer never updates.
      Re-scope every swap to the drawer element, and self-heal by
      refreshing on every open().

   3. REMOVE on a build card only removed the parent line, stranding the
      build's invisible add-on/fee lines in the cart ("removed everything,
      balance remains"). With data-qp-build-keys present, remove the whole
      build in one /cart/update.js call (documented Shopify API, keyed by
      line key — order-independent, no positional races). */
(function () {
  'use strict';

  if (window.__qpCartBuildLoaded) return;
  window.__qpCartBuildLoaded = true;

  var Drawer = customElements.get('m-cart-drawer');
  var DrawerItems = customElements.get('m-cart-drawer-items');

  if (Drawer) {
    Drawer.prototype.onCartDrawerUpdate = function (updateFooter) {
      var self = this;
      if (updateFooter === undefined) updateFooter = true;
      fetch(window.MinimogSettings.routes.cart + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          self.getSectionsToRender().forEach(function (s) {
            if (s.block !== 'cart-items' && !updateFooter) return;
            var target = s.selector ? self.querySelector(s.selector) : document.getElementById(s.id);
            var source = s.selector ? doc.querySelector(s.selector) : null;
            if (target && source) target.innerHTML = source.innerHTML;
          });
        })
        .catch(function () {});
      this.getCart().then(function (cart) {
        self.classList.toggle('m-cart--empty', cart.item_count === 0);
        self.updateCartCount(cart.item_count);
      });
    };

    var origOpen = Drawer.prototype.open;
    Drawer.prototype.open = function (el) {
      try { this.onCartDrawerUpdate(true); } catch (e) { /* self-heal is best-effort */ }
      return origOpen.call(this, el);
    };
  }

  if (DrawerItems) {
    DrawerItems.prototype.onCartUpdate = function () {
      var drawer = document.querySelector('m-cart-drawer');
      if (drawer && drawer.onCartDrawerUpdate) drawer.onCartDrawerUpdate(true);
    };
  }

  // Whole-build remove (capture phase beats m-cart-remove-button's own listener)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('m-cart-remove-button[data-qp-build-keys]');
    if (!btn) return;
    var keys = (btn.getAttribute('data-qp-build-keys') || '').split(',').filter(Boolean);
    if (keys.length < 2) return; // single-line build: vanilla path is correct
    e.preventDefault();
    e.stopImmediatePropagation();
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var isEmpty = cart.item_count === 0;
        var page = document.querySelector('m-cart');
        if (page) page.classList.toggle('m-cart--empty', isEmpty);
        var drawerEl = document.querySelector('m-cart-drawer');
        if (drawerEl) drawerEl.classList.toggle('m-cart--empty', isEmpty);
        if (page && page.onCartUpdate) page.onCartUpdate(true);
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && drawer.onCartDrawerUpdate) drawer.onCartDrawerUpdate(true);
        if (window.MinimogEvents && window.MinimogTheme) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, Object.assign({}, cart, { source: 'qp-build-remove' }));
        }
      })
      .catch(function () {});
  }, true);

  // ── Discount code entry (task #1): APPLY navigates through Shopify's
  // discount-cookie route; the redirect carries qp_applied=<code> so the
  // cart page can confirm the attempt against the ACTUAL allocations in
  // /cart.js — never a fake success state. ──
  function qpApplyDiscount(entry) {
    if (!entry) return;
    var input = entry.querySelector('[data-qp-discount-input]');
    var code = ((input && input.value) || '').trim();
    if (!code) return;
    var params = new URLSearchParams(location.search);
    var pid = params.get('preview_theme_id');
    var redirect = '/cart?qp_applied=' + encodeURIComponent(code) + (pid ? '&preview_theme_id=' + pid : '');
    location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qp-discount-apply]');
    if (!btn) return;
    e.preventDefault();
    qpApplyDiscount(btn.closest('[data-qp-discount-entry]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-qp-discount-input]');
    if (!input) return;
    e.preventDefault();
    qpApplyDiscount(input.closest('[data-qp-discount-entry]'));
  });

  // ── Globo priced-upgrade name resolution (field bug 2026-09-15). A straight
  // PDP add prices Globo "addon product" selections INTO the parent line; the
  // build card renders each `_gpo_addon_products` entry as a └ ADD-ONS row
  // ([data-qp-upgrade-variant]) with the price but only a generic label — the
  // property carries variant id + price, no name. Resolve the name here:
  // /variants/:id 302s to /products/:handle?variant=:id (response.url gives
  // the handle), then /products/:handle.js names the variant. CHOICE-titled
  // machinery products tell the story in the variant title (same doctrine as
  // qp-cart-build-card's value composition). Display-only: any failure leaves
  // the server-rendered fallback text in place. ──
  var qpUpgradeNames = {};
  function qpResolveUpgradeName(vid) {
    if (qpUpgradeNames[vid]) return qpUpgradeNames[vid];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    qpUpgradeNames[vid] = fetch(root + 'variants/' + encodeURIComponent(vid), { redirect: 'follow' })
      .then(function (r) {
        var m = r.url && r.url.match(/\/products\/([^/?#]+)/);
        if (!m) throw new Error('no product handle for variant ' + vid);
        return fetch(root + 'products/' + m[1] + '.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(vid); })[0];
        var vt = v && v.title && v.title !== 'Default Title' ? v.title : '';
        if (/CHOICE/i.test(p.title || '') && vt) return vt;
        return vt ? p.title + ' · ' + vt : p.title || null;
      })
      .catch(function () { return null; });
    return qpUpgradeNames[vid];
  }

  function qpEnrichUpgrades() {
    document.querySelectorAll('[data-qp-upgrade-variant]').forEach(function (row) {
      if (row.hasAttribute('data-qp-upgrade-named')) return;
      row.setAttribute('data-qp-upgrade-named', '');
      qpResolveUpgradeName(row.getAttribute('data-qp-upgrade-variant')).then(function (name) {
        if (!name || !row.isConnected) return;
        var el = row.querySelector('[data-qp-upgrade-name]');
        if (el) el.textContent = name;
      });
    });
  }

  qpEnrichUpgrades();
  // Drawer/page rerenders swap innerHTML wholesale — re-enrich whatever appears.
  new MutationObserver(function () { qpEnrichUpgrades(); }).observe(document.body, { childList: true, subtree: true });

  // Post-redirect verdict: match the attempted code against cart-level
  // applications AND per-line discount titles (product codes land line-level).
  (function () {
    var params = new URLSearchParams(location.search);
    var attempted = params.get('qp_applied');
    if (!attempted) return;
    var code = attempted.toUpperCase();
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var found = (cart.cart_level_discount_applications || []).some(function (d) {
          return (d.title || '').toUpperCase() === code;
        });
        if (!found) {
          found = (cart.items || []).some(function (i) {
            return (i.discounts || []).some(function (d) {
              return (d.title || '').toUpperCase() === code;
            });
          });
        }
        document.querySelectorAll('[data-qp-discount-feedback]').forEach(function (el) {
          var tpl = found ? el.getAttribute('data-qp-ok') : el.getAttribute('data-qp-fail');
          el.textContent = (tpl || '{code}').replace('{code}', code);
          el.classList.toggle('qp-discount-entry__feedback--ok', found);
          el.hidden = false;
        });
      })
      .catch(function () {});
  })();
})();
